module.exports = __webpack_public_path__ + "3f931548097cf64ba6f011c6025e9ac6.png";